package org.example.site_web.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.accelarge.indeffi.webfr.components.forms.inputs.MyTextAreaInput
import com.accelarge.indeffi.webfr.components.forms.inputs.MyTextInputEmail
import com.accelarge.indeffi.webfr.components.forms.inputs.MyTextInputGeneric
import com.accelarge.indeffi.webfr.components.forms.inputs.MyTextInputPhone
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.disabled
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.example.site_web.components.sections.ContactFormData
import org.example.site_web.toSitePalette
import org.jetbrains.compose.web.attributes.AutoComplete.Companion.name
import org.jetbrains.compose.web.attributes.autoComplete
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Fieldset
import org.jetbrains.compose.web.dom.Form
import org.jetbrains.compose.web.dom.Legend
import org.jetbrains.compose.web.dom.TelInput
import org.jetbrains.compose.web.dom.Text

val FormAccStyle = CssStyle.base {
    Modifier
        .position(Position.Relative)
        .border() {
            color(colorMode.toSitePalette().brand.accent2)
            style(LineStyle.Solid)
            width(3.px)
        }
}

@Composable
fun ContactForm(onSubmitClick: (ContactFormData) -> Unit) {
    val contactName = mutableStateOf("")
    val contactCompany = mutableStateOf("")
    val contactPhone = mutableStateOf("")
    val contactEmail = mutableStateOf("")
    val contactProject = mutableStateOf("")
    val trueState = mutableStateOf(true)

    fun formDatas(): ContactFormData {
        return ContactFormData(
            contactName.value,
            contactCompany.value,
            contactPhone.value,
            contactEmail.value,
            contactProject.value)
    }

    Box(Modifier
        .maxWidth(30.cssRem)
        .fontSize(16.px),
        contentAlignment = Alignment.Center) {
        Form(
            attrs = Modifier
                .fillMaxWidth()
                .toAttrs {
                    autoComplete(false)
                    onSubmit { evt ->
                        evt.preventDefault()
                    }
                }
        )
        {
            Fieldset(attrs = FormAccStyle.toModifier()
                .fillMaxWidth()
                .toAttrs {}) {
                Legend(Modifier
                    .fontSize(20.px)
                    .padding(bottom = 2.px)
                    .toAttrs{}) {
                    Text("Formulaire de Contact")
                }

                Column(Modifier
                    .displayIfAtLeast(Breakpoint.LG)
                    .fillMaxWidth()
                    .padding(1.cssRem),
                    verticalArrangement = Arrangement.spacedBy(1.cssRem),) {
                    Row(
                        Modifier
                            .fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(1.cssRem)
                    ) {
                        NameInput(contactName)
                        CompanyInput(contactCompany)
                    }
                    Row(
                        Modifier
                            .fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(1.cssRem)
                    ) {
                        Box(modifier = Modifier.width(10.cssRem)) {
                            TelInput(contactPhone)
                        }
                        MailInput(contactEmail)
                    }
                    Row(
                        Modifier
                            .fillMaxWidth()
                    ) {
                        AreaInput(contactProject)
                    }
                    Row(Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.Center) {
                        Submit(onSubmitClick, { formDatas() })
                    }
                }
                Column(Modifier
                    .displayUntil(Breakpoint.LG)
                    .fillMaxWidth()
                    .padding(0.25.cssRem),
                    verticalArrangement = Arrangement.spacedBy(1.cssRem),
                    horizontalAlignment = Alignment.CenterHorizontally) {
                        NameInput(contactName)
                        CompanyInput(contactCompany)
                        Box(modifier = Modifier.width(10.cssRem)) {
                            TelInput(contactPhone)
                        }
                        MailInput(contactEmail)
                        AreaInput(contactProject)
                        Submit(onSubmitClick, { formDatas() })
                }
            }
        }
    }
}


@Composable
fun NameInput(state:MutableState<String>){
    MyTextInputGeneric(
        state,
        id = "name",
        label = "Nom-Prénom",
        placeholder = "ex: mon nom",
        editableState = mutableStateOf(true),
        validationRegExp = "[A-Za-zéèêëç\\-]{1,30}",
        validationInfoText = "Caractère non-attendu"
    )

}

@Composable
fun CompanyInput(state:MutableState<String>){
    MyTextInputGeneric(
        state,
        id = "name",
        label = "Société/Organisme",
        placeholder = "ex: ma société",
        editableState = mutableStateOf(true),
        validationRegExp = "[A-Za-zéèêëç\\-]{1,30}",
        validationInfoText = "Caractère non-attendu"
    )
}

@Composable
fun TelInput(state:MutableState<String>){
        MyTextInputPhone(
            state,
            id = "phone",
            label = "Téléphone",
            editableState = mutableStateOf(true),
        )
}

@Composable
fun MailInput(state:MutableState<String>){
    MyTextInputEmail(
        state,
        id = "name",
        label = "E-mail",
        editableState = mutableStateOf(true),
    )
}

@Composable
fun AreaInput(state:MutableState<String>){
    MyTextAreaInput(
        state,
        placeholder = "Votre projet en quelques mots",
        id = "project-desc",
        label = "Votre Projet",
        editableState = mutableStateOf(true),
    )
}
@Composable
fun Submit(onSubmitClick: (ContactFormData) -> Unit, dataProvider:()-> ContactFormData) {
    Button(Modifier
        .fontSize(1.cssRem)
        .maxWidth(16.em)
        .disabled(true)
        .toAttrs {
            onClick  { evt ->
                evt.preventDefault()
                onSubmitClick(dataProvider())
            }
        }) {
    Text("Formulaire en cours de création\r\nMerci de nous contacter à \r\ncontact@accelarge.com")
    //Text("Soumettre la demande")
    }
}
